import { render, staticRenderFns } from "./loyaltySvg.vue?vue&type=template&id=45cca60c"
import script from "./loyaltySvg.vue?vue&type=script&lang=js"
export * from "./loyaltySvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports